import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

// A 401 from these endpoints means "wrong credentials", not "session expired" — let
// the login/register components handle it themselves rather than forcing a redirect.
const CREDENTIAL_ENDPOINTS = [`${environment.apiUrl}/auth/login`, `${environment.apiUrl}/auth/register`];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach the token to our own API — never to third-party/external requests.
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const auth = inject(AuthService);
  const token = auth.getToken();
  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  return next(req).pipe(
    catchError((err: unknown) => {
      const isCredentialEndpoint = CREDENTIAL_ENDPOINTS.some(url => req.url.startsWith(url));
      if (err instanceof HttpErrorResponse && err.status === 401 && !isCredentialEndpoint) {
        auth.forceLogout();
      }
      return throwError(() => err);
    })
  );
};

